import { useState } from "react";
import { useAuth } from "../auth.js";
import { useLocale } from "../ui.js";
import { AccountsPanel } from "./AccountsPanel.js";
import { MembershipPanel } from "./MembershipPanel.js";
import { ModuleFlagsPanel } from "./ModuleFlagsPanel.js";
import { CmsPanel } from "./CmsPanel.js";
import { AuditPanel } from "./AuditPanel.js";
import { JarvisControlPanel } from "./JarvisControlPanel.js";
import { MobileActionSyncPanel } from "./MobileActionSyncPanel.js";
import { BrowserExtensionSetupPanel } from "./BrowserExtensionSetupPanel.js";
import type { TranslateKey } from "../i18n.js";

type OwnerTab = "accounts" | "memberships" | "modules" | "cms" | "audit" | "jarvis" | "mobile" | "browserExtension";

const OWNER_TABS: { id: OwnerTab; label: TranslateKey }[] = [
  { id: "accounts", label: "accounts" },
  { id: "memberships", label: "memberships" },
  { id: "modules", label: "modules" },
  { id: "cms", label: "cms" },
  { id: "audit", label: "audit" },
  { id: "jarvis", label: "jarvis" },
  { id: "mobile", label: "mobile" },
  { id: "browserExtension", label: "browserExtension" },
];

export function OwnerConsole({ token }: { token: string }) {
  const { tr } = useLocale();
  const { logout } = useAuth();
  const [tab, setTab] = useState<OwnerTab>("accounts");

  return (
    <section className="panel-card">
      <div className="owner-console">
        <aside className="owner-console-nav">
          <div className="eyebrow">{tr("ownerConsole")}</div>
          <nav className="ss-sidebar-group">
            {OWNER_TABS.map((item) => (
              <button
                key={item.id}
                className={`ss-side-item ${tab === item.id ? "active" : ""}`}
                onClick={() => setTab(item.id)}
              >
                {tr(item.label)}
              </button>
            ))}
            <button className="ss-side-item" onClick={() => void logout()}>
              {tr("logout")}
            </button>
          </nav>
        </aside>
        <div className="owner-console-body">
          {tab === "accounts" ? <AccountsPanel token={token} /> : null}
          {tab === "memberships" ? <MembershipPanel token={token} /> : null}
          {tab === "modules" ? <ModuleFlagsPanel token={token} /> : null}
          {tab === "cms" ? <CmsPanel token={token} /> : null}
          {tab === "audit" ? <AuditPanel token={token} /> : null}
          {tab === "jarvis" ? <JarvisControlPanel token={token} /> : null}
          {tab === "mobile" ? <MobileActionSyncPanel token={token} /> : null}
          {tab === "browserExtension" ? <BrowserExtensionSetupPanel token={token} /> : null}
        </div>
      </div>
    </section>
  );
}
